var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRoute)?_c('router-link',{class:_vm.$style.sidebar,attrs:{"to":_vm.pathTo}},[_c('span',{class:_vm.$style.text},[_vm._t("default")],2)]):_c('a',{class:_vm.$style.sidebar,attrs:{"href":_vm.pathTo,"aria-label":"Кнопка слайдера"}},[_c('span',{class:_vm.$style.text},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06652092","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseSideButton.vue
// module id = null
// module chunks = 